import { Alert, Button, Modal, Spinner } from "react-bootstrap";

/**
 * Standard "unsaved changes" guard modal used by all edit tab pages.
 * The parent provides onSave / onDiscard / onCancel callbacks and its own saving/error state.
 */
export default function NavGuardModal({
  show,
  saving,
  error,
  onSave,
  onDiscard,
  onCancel,
  title = "Unsaved Changes",
  body = "You have unsaved changes. Would you like to save them before leaving?",
  saveLabel = "Save & Continue",
  discardLabel = "Discard & Leave",
}) {
  return (
    <Modal show={show} centered onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      {error && (
        <Alert variant="danger" className="mx-3 mb-0 mt-2">
          {error}
        </Alert>
      )}
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel} disabled={saving}>
          Cancel
        </Button>
        <Button variant="outline-danger" onClick={onDiscard} disabled={saving}>
          {discardLabel}
        </Button>
        <Button variant="primary" onClick={onSave} disabled={saving}>
          {saving ? (
            <><Spinner animation="border" size="sm" className="me-1" />Saving...</>
          ) : (
            saveLabel
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
